import script from "./Recharge.vue?vue&type=script&setup=true&lang=js"
export * from "./Recharge.vue?vue&type=script&setup=true&lang=js"

import "./Recharge.vue?vue&type=style&index=0&id=94d5196a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d5196a"]])

export default __exports__